// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterToggle-cls1_zrt","cls2":"FilterToggle-cls2_m8b FilterToggle-cls1_zrt","mobileLayout":"FilterToggle-mobileLayout_ABW"};